export default __webpack_public_path__ + "static/media/arrowRight.f19bcfab.svg";